import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_TAN_WAVE_TRACE_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-tan-wave-trace',
  type: 'unit-circle',
  params: {
    point: { angle: 0 },
    trigLines: { lines: ['tan'] },
    traceWave: 'tan',
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 9, yStart: -4, yEnd: 4 },
      grid: { type: 'lines', visible: true },
    },
  },
};
